import { toast } from 'react-toastify';

const toaster = {
  success(msg) {
    return toast.success(msg || 'Success');
  },

  error(err, msg = 'An error has occurred') {
    if (err && err.response && err.response.data) {
      const data = err.response.data;
      if (typeof data === 'string' && data.length) {
        msg = data;
      } else if (data.errorMessage) {
        msg = data.errorMessage;
      } else if (data.message) {
        msg = data.message;
      } else if (data.detail) {
        msg = data.detail;
      } else if (data.title) {
        msg = data.title;
      }
    }

    return toast.error(msg);
  },

  warn(err, options) {
    return toast.warn(err, options);
  },

  dismiss(toastId) {
    toast.dismiss(toastId.current);
  }
};

export default toaster;
